export const INITIAL_DATA_SET = 'at/kanban/INITIAL_DATA_SET'
export const COLLAPSED_PROJECTS_CHANGE = 'at/kanban/COLLAPSED_PROJECTS_CHANGE'
export const TASKS_ADD = 'at/kanban/TASKS_ADD'
export const PROJECT_LOADING_POSITION_SET = 'at/kanban/PROJECT_LOADING_POSITION_SET'
export const PROJECT_LOADING_POSITIONS_RESET = 'at/kanban/PROJECT_LOADING_POSITIONS_RESET'
export const LOADING_INITIAL_DATA_SET = 'at/kanban/LOADING_INITIAL_DATA_SET'
export const LOADING_PROJECT_ID_SET = 'at/kanban/LOADING_PROJECT_ID_SET'
export const IS_LOADED_SET = 'at/kanban/IS_LOADED_SET'
export const TASKS_COUNT_BY_WORKFLOW_STATUS_SET = 'at/kanban/TASKS_COUNT_BY_WORKFLOW_STATUS_SET'
export const MINIMIZED_CARDS_SET = 'at/kanban/MINIMIZED_CARDS_SET'
export const TASKS_ORDER_PREPEND = 'at/kanban/TASKS_ORDER_PREPEND'
export const TASKS_ORDER_ADD = 'at/kanban/TASKS_ORDER_ADD'
export const TASKS_ORDER_SET = 'at/kanban/TASKS_ORDER_SET'
export const UPDATING_TASK_ADD = 'at/kanban/UPDATING_TASK_ADD'
export const UPDATING_TASK_REMOVE = 'at/kanban/UPDATING_TASK_REMOVE'
export const LOADED_TASKS_NAME_FILTER_SET = 'at/kanban/LOADED_TASKS_NAME_FILTER_SET'
export const PROJECTS_IDS_CONTAINING_TASK_ADD = 'at/kanban/PROJECTS_IDS_CONTAINING_TASK_ADD'
export const NEED_TO_LOAD_COUNTERS_SET = 'at/kanban/NEED_TO_LOAD_COUNTERS_SET'


// WEBPACK FOOTER //
// ./web/js/taskManagement/kanban/actionTypes.js